import React from 'react';
import Headline from '../Headline';
import { ActionBar } from '../ActionBar';
import HeadlineTimestamp from '../Headline/components/HeadlineTimestamp';
import { isGamesPost } from '../../utils/games';
import { getBreadcrumbs } from '../Headline/components/HeadlineBreadcrumb/breadcrumbs';
import { getShoppingHeaderImage, DEFAULT_SHOPPING_HEADER_IMAGE } from '../../utils/shoppingHeaderImages';
import styles from './postHead.module.scss';

const PostHead = ({
  buzz,
  badges,
  commentCount,
  destination,
  showShareBar,
  isFloatingButtonsEnd,
}) => {
  const isGames = isGamesPost(buzz);
  const isQuiz = buzz.isQuiz && !isGames;
  const timestampPublished = Number(buzz.published);
  const timestampUpdated =
    'edit_updated' in buzz ? Number(buzz.edit_updated) : 0;
  const showUpdatedTimestampOnly = buzz.tags.includes(
    '--updated-timestamp-only'
  );
  const isShopping = buzz.isShopping;
  const isUSShopping = isShopping && buzz.country_code === 'en-us';

  // Get breadcrumbs and determine shopping header image
  let shoppingImage = DEFAULT_SHOPPING_HEADER_IMAGE;
  if (isUSShopping) {
    const { secondary } = getBreadcrumbs(buzz, badges);
    shoppingImage = getShoppingHeaderImage(secondary);
  }
  
  return (
    <header className={`${styles.postHead} ${isGames ? styles.games : ''} ${isQuiz ? styles.quiz : ''} ${isUSShopping ? styles.shopping : ''} postHead`}>
      <div className={styles.container}>
        <Headline
          buzz={buzz}
          badges={badges}
          designUpdateEnabled={true}
          isGames={isGames}
          isQuiz={isQuiz}
          shoppingImage={isUSShopping ? shoppingImage : null}
        />
        <div className={styles.actionBarWrapper}>
          <HeadlineTimestamp
            className={styles.timestamp}
            timestampPublishedUnix={timestampPublished}
            timestampUpdatedUnix={timestampUpdated}
            showUpdatedTimestampOnly={showUpdatedTimestampOnly}
            countryCode={buzz.country_code}
            destination={destination}
          />
          <ActionBar
            buzz={buzz}
            commentCount={commentCount}
            showShareBar={showShareBar}
            destination={destination}
            isFloatingButtonsEnd={isFloatingButtonsEnd}
            designUpdateEnabled={true}
            isQuiz={isQuiz}
          />
        </div>
      </div>
    </header>
  );
};

export default PostHead;
